<template>
  <div class="page settings-page">
    <h2 class="page-title">系统设置</h2>
    <el-tabs v-model="activeTab" class="settings-tabs">
      <!-- 积分设置 -->
      <el-tab-pane label="积分设置" name="integral">
        <div class="settings-card">
          <div class="settings-section-title">巡护积分规则</div>
          <el-form :model="integralForm" label-width="160px" size="small" v-loading="integralLoading">
            <el-form-item label="每次巡护积分">
              <el-input-number v-model="integralForm.patrolIntegral" :min="0" :max="9999" />
              <span class="unit-tip">分/次</span>
            </el-form-item>
            <el-form-item label="首次认领奖励积分">
              <el-input-number v-model="integralForm.claimIntegral" :min="0" :max="9999" />
              <span class="unit-tip">分</span>
            </el-form-item>
            <el-form-item label="上报泉井奖励积分">
              <el-input-number v-model="integralForm.reportIntegral" :min="0" :max="9999" />
              <span class="unit-tip">分</span>
            </el-form-item>
            <el-form-item label="提交线索奖励积分">
              <el-input-number v-model="integralForm.clueIntegral" :min="0" :max="9999" />
              <span class="unit-tip">分</span>
            </el-form-item>
            <el-form-item label="提交检测申请积分">
              <el-input-number v-model="integralForm.testApplyIntegral" :min="0" :max="9999" />
              <span class="unit-tip">分</span>
            </el-form-item>
            <el-form-item label="提交修缮申请积分">
              <el-input-number v-model="integralForm.repairApplyIntegral" :min="0" :max="9999" />
              <span class="unit-tip">分</span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveIntegral" :loading="integralSaving">保存设置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
      <!-- 功能开关 -->
      <el-tab-pane label="功能开关" name="feature">
        <div class="settings-card">
          <div class="settings-section-title">小程序入口控制</div>
          <el-form :model="featureForm" label-width="180px" size="small" v-loading="featureLoading">
            <el-form-item label="我要捐赠">
              <el-switch
                v-model="featureForm.donationEnabled"
                active-text="显示"
                inactive-text="隐藏"
              />
              <div class="setting-tip">关闭后，小程序泉井详情、个人中心、心愿榜等位置的“我要捐赠/捐赠支持”入口将隐藏。</div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveFeature" :loading="featureSaving">保存设置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>

      <!-- 首页广告图设置 -->
      <el-tab-pane label="首页广告图" name="banner">
        <div class="settings-card">
          <div class="settings-section-title">广告轮播图管理</div>
          <div class="banner-list" v-loading="bannerLoading">
            <div v-for="(item, idx) in bannerList" :key="idx" class="banner-item">
              <div class="banner-preview">
                <el-image v-if="item.imgUrl" :src="resolveImageUrl(item.imgUrl)" fit="cover" class="banner-img" />
                <div v-else class="banner-empty">暂无图片</div>
              </div>
              <div class="banner-info">
                <el-form :model="item" size="small" label-width="80px">
                  <el-form-item label="图片">
                    <input :ref="'bannerFile' + idx" type="file" accept="image/*" style="display:none" @change="handleBannerUpload($event, idx)" />
                    <el-button size="mini" icon="el-icon-upload2" :loading="item.uploading" @click="chooseBannerImage(idx)">{{ item.imgUrl ? '替换图片' : '上传图片' }}</el-button>
                  </el-form-item>
                  <el-form-item label="跳转链接">
                    <el-input v-model="item.linkUrl" placeholder="默认跳转：/pages/mine_sub/well-clue/index" />
                  </el-form-item>
                  <el-form-item label="标题">
                    <el-input v-model="item.title" placeholder="广告图标题（可选）" />
                  </el-form-item>
                  <el-form-item label="排序">
                    <el-input-number v-model="item.sort" :min="1" :max="99" style="width:100px" />
                  </el-form-item>
                  <el-form-item label="状态">
                    <el-switch v-model="item.enabled" active-text="启用" inactive-text="停用" />
                  </el-form-item>
                </el-form>
              </div>
              <div class="banner-actions">
                <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="removeBanner(idx)" />
              </div>
            </div>
            <el-button class="add-banner-btn" icon="el-icon-plus" @click="addBanner">添加广告图</el-button>
          </div>
          <el-button type="primary" style="margin-top:20px" @click="saveBanners" :loading="bannerSaving">保存广告图</el-button>
        </div>
      </el-tab-pane>

      <!-- 账号管理 -->
      <el-tab-pane label="账号管理" name="account">
        <div class="settings-card">
          <div class="settings-section-title">管理员账号</div>
          <el-table class="admin-table" :data="adminList" border size="small" v-loading="accountLoading">
            <el-table-column prop="id" label="ID" width="70" align="center" />
            <el-table-column prop="username" label="账号" min-width="150" />
            <el-table-column prop="nickname" label="昵称" min-width="160" />
            <el-table-column label="角色" min-width="130" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.role === 'super' ? 'danger' : 'primary'" size="small">{{ scope.row.role === 'super' ? '超级管理员' : '管理员' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="状态" min-width="100" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.enabled ? 'success' : 'info'" size="small">{{ scope.row.enabled ? '启用' : '停用' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="创建时间" min-width="180" />
            <el-table-column label="操作" min-width="180" align="center">
              <template slot-scope="scope">
                <div class="action-bar">
                  <span class="action-text edit" @click="openEditAdmin(scope.row)">修改</span>
                  <span class="action-text pwd" @click="openChangePwd(scope.row)">改密</span>
                  <span v-if="scope.row.role !== 'super'" class="action-text delete" @click="doDeleteAdmin(scope.row)">删除</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddAdmin">新增管理员</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog :title="adminDialogMode === 'add' ? '新增管理员' : '修改管理员'" :visible.sync="adminDialogVisible" width="440px">
      <el-form ref="adminForm" :model="adminForm" :rules="adminRules" label-width="80px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="adminForm.username" :disabled="adminDialogMode === 'edit'" />
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="adminForm.nickname" />
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="adminDialogMode === 'add'">
          <el-input v-model="adminForm.password" show-password />
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="adminForm.role">
            <el-option label="管理员" value="admin" />
            <el-option label="超级管理员" value="super" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="adminForm.enabled" active-text="启用" inactive-text="停用" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="adminDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAdmin">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="pwdDialogVisible" width="380px">
      <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="90px">
        <el-form-item label="新密码" prop="newPwd">
          <el-input v-model="pwdForm.newPwd" show-password placeholder="请输入新密码" />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPwd">
          <el-input v-model="pwdForm.confirmPwd" show-password placeholder="请再次输入新密码" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="pwdDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitChangePwd">确认修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchSettings, saveSettings, fetchAdminList, addAdmin, updateAdmin, deleteAdminAccount, changeAdminPwd, fetchBanners, saveBanners as saveBannersApi, uploadImage } from '@/api'
import { resolveImageUrl } from '@/utils/media'

export default {
  data() {
    const confirmPwdValidator = (rule, value, cb) => {
      if (value !== this.pwdForm.newPwd) cb(new Error('两次密码不一致'))
      else cb()
    }
    return {
      activeTab: 'integral',
      integralLoading: false,
      integralSaving: false,
      integralForm: { patrolIntegral: 10, claimIntegral: 50, reportIntegral: 20, clueIntegral: 5, testApplyIntegral: 10, repairApplyIntegral: 10 },
      featureLoading: false,
      featureSaving: false,
      featureForm: { donationEnabled: true },
      bannerLoading: false,
      bannerSaving: false,
      defaultBannerLink: '/pages/mine_sub/well-clue/index',
      bannerList: [],
      accountLoading: false,
      adminList: [{ id: 1, username: 'admin', nickname: '超级管理员', role: 'super', enabled: true, createdAt: '2024-01-01' }],
      adminDialogVisible: false,
      adminDialogMode: 'add',
      adminForm: { id: null, username: '', nickname: '', password: '', role: 'admin', enabled: true },
      adminRules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { min: 6, message: '密码至少6位', trigger: 'blur' }]
      },
      pwdDialogVisible: false,
      pwdForm: { id: null, newPwd: '', confirmPwd: '' },
      pwdRules: {
        newPwd: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { min: 6, message: '至少6位', trigger: 'blur' }],
        confirmPwd: [{ required: true, message: '请确认密码', trigger: 'blur' }, { validator: confirmPwdValidator, trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadIntegral()
    this.loadFeature()
    this.loadBanners()
    this.loadAdminList()
  },
  methods: {
    resolveImageUrl,
    async loadIntegral() {
      this.integralLoading = true
      try {
        const res = await fetchSettings('integral')
        if (res) Object.assign(this.integralForm, res)
      } catch (e) {} finally { this.integralLoading = false }
    },
    async saveIntegral() {
      this.integralSaving = true
      try {
        await saveSettings({ type: 'integral', ...this.integralForm })
        this.$message.success('积分设置已保存')
      } catch (e) { this.$message.error('保存失败，请稍后重试') } finally { this.integralSaving = false }
    },
    async loadFeature() {
      this.featureLoading = true
      try {
        const res = await fetchSettings('feature')
        if (res) Object.assign(this.featureForm, { donationEnabled: res.donationEnabled !== false })
      } catch (e) {} finally { this.featureLoading = false }
    },
    async saveFeature() {
      this.featureSaving = true
      try {
        await saveSettings({ type: 'feature', donationEnabled: !!this.featureForm.donationEnabled })
        this.$message.success('功能开关已保存')
      } catch (e) { this.$message.error('保存失败，请稍后重试') } finally { this.featureSaving = false }
    },
    async loadBanners() {
      this.bannerLoading = true
      try {
        const res = await fetchBanners()
        this.bannerList = (res || []).map(item => ({
          ...item,
          linkUrl: item.linkUrl || this.defaultBannerLink,
          uploading: false
        }))
      } catch (e) { this.bannerList = [] } finally { this.bannerLoading = false }
    },
    addBanner() {
      this.bannerList.push({ imgUrl: '', linkUrl: this.defaultBannerLink, title: '', sort: this.bannerList.length + 1, enabled: true, uploading: false })
    },
    removeBanner(idx) { this.bannerList.splice(idx, 1) },
    chooseBannerImage(idx) {
      const inputRef = this.$refs['bannerFile' + idx]
      const input = Array.isArray(inputRef) ? inputRef[0] : inputRef
      if (input) input.click()
    },
    async handleBannerUpload(e, idx) {
      const file = e.target.files[0]
      if (!file) return
      this.$set(this.bannerList[idx], 'uploading', true)
      try {
        const url = await uploadImage(file)
        this.$set(this.bannerList[idx], 'imgUrl', url)
        if (!this.bannerList[idx].linkUrl) this.$set(this.bannerList[idx], 'linkUrl', this.defaultBannerLink)
        this.$message.success('图片上传成功，请点击保存广告图生效')
      } catch (err) {
        this.$message.error('图片上传失败')
      } finally {
        this.$set(this.bannerList[idx], 'uploading', false)
        e.target.value = ''
      }
    },
    async saveBanners() {
      this.bannerSaving = true
      try {
        const payload = this.bannerList.map(item => ({
          id: item.id,
          imgUrl: item.imgUrl,
          linkUrl: item.linkUrl || this.defaultBannerLink,
          title: item.title || '',
          sort: item.sort || 1,
          enabled: item.enabled
        }))
        await saveBannersApi(payload)
        this.$message.success('广告图已保存')
      } catch (e) { this.$message.error('保存失败，请稍后重试') } finally { this.bannerSaving = false }
    },
    async loadAdminList() {
      this.accountLoading = true
      try {
        const res = await fetchAdminList()
        if (res && res.length) this.adminList = res
      } catch (e) {} finally { this.accountLoading = false }
    },
    openAddAdmin() {
      this.adminDialogMode = 'add'
      this.adminForm = { id: null, username: '', nickname: '', password: '', role: 'admin', enabled: true }
      this.adminDialogVisible = true
    },
    openEditAdmin(row) {
      this.adminDialogMode = 'edit'
      this.adminForm = { ...row }
      this.adminDialogVisible = true
    },
    submitAdmin() {
      this.$refs.adminForm.validate(async valid => {
        if (!valid) return
        try {
          if (this.adminDialogMode === 'add') {
            await addAdmin(this.adminForm)
            this.$message.success('新增成功')
          } else {
            await updateAdmin(this.adminForm)
            this.$message.success('修改成功')
          }
          this.adminDialogVisible = false
          this.loadAdminList()
        } catch (e) { this.$message.error('操作失败，请稍后重试') }
      })
    },
    async doDeleteAdmin(row) {
      try {
        await this.$confirm(`确认删除管理员「${row.username}」吗？`, '删除确认', { type: 'warning' })
        await deleteAdminAccount(row.id)
        this.$message.success('已删除')
        this.loadAdminList()
      } catch (e) {}
    },
    openChangePwd(row) {
      this.pwdForm = { id: row.id, newPwd: '', confirmPwd: '' }
      this.pwdDialogVisible = true
    },
    submitChangePwd() {
      this.$refs.pwdForm.validate(async valid => {
        if (!valid) return
        try {
          await changeAdminPwd({ id: this.pwdForm.id, password: this.pwdForm.newPwd })
          this.$message.success('密码已修改')
          this.pwdDialogVisible = false
        } catch (e) { this.$message.error('修改失败，请稍后重试') }
      })
    }
  }
}
</script>

<style scoped>
.settings-tabs ::v-deep .el-tabs__header { background: #fff; border-radius: 12px 12px 0 0; padding: 0 16px; margin-bottom: 0; }
.settings-tabs ::v-deep .el-tabs__content { overflow: visible; }
.settings-card { background: #fff; border-radius: 0 0 12px 12px; padding: 28px 28px 24px; box-shadow: 0 2px 14px rgba(0,0,0,.06); overflow: visible; }
.settings-section-title { font-size: 15px; font-weight: 700; color: #123c2f; margin-bottom: 20px; padding-bottom: 10px; border-bottom: 1px solid #eee; }
.setting-tip { margin-top: 10px; color: #909399; font-size: 12px; line-height: 1.5; }
.unit-tip { margin-left: 8px; color: #909399; font-size: 13px; }
.banner-list { display: flex; flex-direction: column; gap: 16px; width: 100%; }
.banner-item { display: grid; grid-template-columns: 220px minmax(360px, 1fr) 40px; gap: 18px; background: #f7f9fc; border-radius: 12px; padding: 18px; align-items: flex-start; width: 100%; box-sizing: border-box; }
.banner-preview { width: 220px; flex-shrink: 0; }
.banner-img { width: 220px; height: 108px; border-radius: 8px; display: block; }
.banner-empty { width: 220px; height: 108px; background: #eee; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #bbb; font-size: 13px; }
.banner-info { min-width: 0; }
.banner-info ::v-deep .el-form-item { margin-bottom: 14px; }
.banner-info ::v-deep .el-form-item:last-child { margin-bottom: 0; }
.banner-info ::v-deep .el-input { width: 100%; }
.banner-actions { display: flex; flex-direction: column; align-items: center; gap: 8px; padding-top: 4px; }
.add-banner-btn { width: 100%; height: 42px; line-height: 40px; border: 1.5px dashed #c0c4cc; color: #606266; border-radius: 8px; background: #fff; display: flex; align-items: center; justify-content: center; }
.add-banner-btn:hover { border-color: #2eb67d; color: #2eb67d; background: #f6fffb; }
.admin-table { width: 100%; margin-bottom: 16px; }
.admin-table ::v-deep .el-table__body-wrapper { overflow-x: auto; }
.admin-table ::v-deep .el-table__fixed-right { display: none; }
.admin-table ::v-deep .el-table__fixed-right-patch { display: none; }
.action-bar { display: flex; justify-content: center; align-items: center; gap: 14px; white-space: nowrap; }
.action-text { cursor: pointer; font-size: 13px; }
.action-text:hover { text-decoration: underline; }
.action-text.edit { color: #409eff; }
.action-text.pwd { color: #e6a23c; }
.action-text.delete { color: #f56c6c; }
@media (max-width: 1100px) {
  .banner-item { grid-template-columns: 1fr; }
  .banner-preview, .banner-img, .banner-empty { width: 100%; max-width: 360px; }
  .banner-actions { align-items: flex-start; }
}
</style>
